import { useQuery } from '@tanstack/react-query';

import { getFormattedNaicsCodes } from './naicsCode.service';
import { NAICS_CODE_QUERY_KEY } from './naicsCodeQueryKeys';

import { TBusinessSector } from '@/shared/types';

export const useGetFormattedNaicsCodes = (): ReturnType<typeof useQuery<TBusinessSector[]>> =>
	useQuery({
		queryFn: getFormattedNaicsCodes,
		queryKey: NAICS_CODE_QUERY_KEY.naicsCodes.formattedList().queryKey,
		gcTime: Infinity,
		staleTime: Infinity,
	});
